import React from 'react'

import { FiInfo } from 'react-icons/fi'
import Tooltip from 'react-tooltip'

import style from './Title.module.scss'

const Extras = ({ 
  microcopy,
  param,
  parent
}) => {
  const explicitlyRequired = param.required && (!parent || parent.required)
  const optionallyRequired = param.required

  return (
    <>
      <span className= { style.loc }>
        { microcopy.text(`reference.parameter_location.${param.location}`) || 
          microcopy.text('reference.parameter_location.body') }
      </span>

      { param.location === 'header' && <>
        <FiInfo data-tip={ microcopy.text('reference.tooltips.header') } />
        <Tooltip place="right" type="info" effect="solid" textColor='#485156' backgroundColor='#fbfbfc' border borderColor='#f5f5f5' />
      </>}
  
      { (param.type !== 'object' || param.nullable) && (
        <span className={ style.optional } data-required={explicitlyRequired} data-optionally-required={optionallyRequired}>
        { explicitlyRequired ? microcopy.text('reference.parameter_details.required') : (
          optionallyRequired ? microcopy.text('reference.parameter_details.conditionally_required') : microcopy.text('reference.parameter_details.optional')
        )}
            
        </span>
      )}
    </>
  )
}

export default Extras